/* import __COLOCATED_TEMPLATE__ from './chart-header-custom-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();